import type { PiprBundle } from '../pipr/types';

const DAY_SEC = 86_400;

export interface CardFigures {
    rateBp: number | null;
    impliedForTs: number | null;
    changeBp: number | null;
    changeDays: number;
    nextDecisionTs: number | null;
    modalDeltaBp: number | null;
    modalPermille: number | null;
    asofTs: number;
}

export function cardFigures(data: PiprBundle, changeDays = 7): CardFigures {
    const h = data.history;
    const front = data.forward.meetings[0] ?? null;

    let changeBp: number | null = null;
    if (h.n > 1) {
        const lastTs = h.ts[h.n - 1];
        const target = lastTs - changeDays * DAY_SEC;
        let k = -1;
        for (let i = h.n - 1; i >= 0; i--) {
            if (h.ts[i] <= target) {
                k = i;
                break;
            }
        }
        if (k >= 0) changeBp = h.impliedBp[h.n - 1] - h.impliedBp[k];
    }

    let modal: number | null = null;
    if (front) {
        modal = 0;
        for (let j = 1; j < front.p.length; j++) {
            if (front.p[j] > front.p[modal]) modal = j;
        }
    }

    return {
        rateBp: front ? front.rateBp : h.n > 0 ? h.impliedBp[h.n - 1] : null,
        impliedForTs: front ? front.decisionTs : null,
        changeBp,
        changeDays,
        nextDecisionTs: front ? front.decisionTs : null,
        modalDeltaBp:
            front && modal !== null ? data.forward.deltas[modal] : null,
        modalPermille: front && modal !== null ? front.p[modal] : null,
        asofTs: data.forward.asofTs,
    };
}
